export const RESERVED_TOP_LEVEL_BUSINESS_SLUGS = new Set([
  "care",
  "rentals",
  "booking",
  "book",
  "capture",
  "biz",
  "login",
  "signup",
  "share",
  "api",
  "graphql",
  "about",
  "privacy",
  "terms",
  "faq",
  "search",
  "category",
  "coins",
  "care-directory",
  "resident-management",
  "emar",
  "myschedule",
  "myjob",
  "referrer",
]);

export const CONFUSING_BUSINESS_SLUGS = new Set([
  ...RESERVED_TOP_LEVEL_BUSINESS_SLUGS,
  "business",
]);

export const BUSINESS_SLUG_RE = /^[a-zA-Z0-9-_.]*$/;

export const normalizeBusinessSlug = (value) => {
  const raw = String(value || "").trim().toLowerCase();
  if (!raw) return "";

  const cleaned = raw.replace(/^\/+|\/+$/g, "");
  if (!cleaned) return "";

  const parts = cleaned.split("/").filter(Boolean);
  if (!parts.length) return "";

  return parts[0] === "b" && parts[1] ? parts[1] : parts[0];
};

export const hasValidBusinessSlugCharacters = (value) =>
  BUSINESS_SLUG_RE.test(String(value || ""));

export const getBusinessSlugAdvisory = (value) => {
  const slug = normalizeBusinessSlug(value);
  if (!slug || !CONFUSING_BUSINESS_SLUGS.has(slug)) return "";

  return `"${slug}" can be confusing because it matches a Plany365 route. We recommend using a more specific business URL.`;
};
